import { Component } from 'vue-property-decorator'
import { BaseTable } from '@/mixins/Base'
import { ResourceVersionDto } from '@/service-proxies/app-v2/dnc.service-proxies'

@Component
export default class VersionTable extends BaseTable<ResourceVersionDto> {
  public currentTr: any = null
  get customRow() {
    return (record, index) => ({
      on: {
        click: e => {
          if (this.currentTr) {
            this.currentTr.style.background = '#fff'
          }
          this.currentTr = document.querySelector(`tr[data-row-key="${index}"]`)
          this.currentTr.style.background = '#d0edff'
          this.$emit('select', { record, index })
        }
      }
    })
  }
  get columns() {
    return [
      {
        title: this.$t('page_resource_pool_no'),
        customRender: (_value, _record, index) => {
          return index + 1
        }
      },
      {
        title: this.$t('page_resource_pool_version'),
        dataIndex: 'displayName',
        customRender: (value, _record, index) => {
          return (
            <span>
              {value}{' '}
              {index === this.data.length - 1 ? (
                <a-tag color="blue">{this.$t('page_resource_pool_latest_version')}</a-tag>
              ) : (
                ''
              )}
            </span>
          )
        }
      },
      {
        title: this.$t('page_resource_pool_use'),
        customRender: (_value, record) => {
          return <a-switch checked={record.currentUsed} onChange={() => this.$emit('use', record.id)} />
        }
      }
    ]
  }

  async clickTr(index) {
    await this.$nextTick()
    const tr: any = document.querySelector(`tr[data-row-key="${index}"]`)
    if (tr) {
      tr.click()
    }
  }

  mounted() {
    this.clickTr(0)
  }

  render() {
    return (
      <a-table
        size="small"
        bordered={true}
        columns={this.columns}
        dataSource={this.data}
        loading={this.loading}
        pagination={false}
        rowKey="index"
        style={{ marginBottom: '16px' }}
        customRow={this.customRow}
      ></a-table>
    )
  }
}
